
export class UserProfile {
    "loginName":  string;
    "email":      string;

    constructor(){

    }
}